import React from "react"
import { ThemeProvider } from "styled-components"
import { theme } from "../styles/theme"
import { GlobalStyles } from "../styles"
import { ChildrenProps } from "../@types/@core"

export const UIThemeProvider: React.FC<ChildrenProps> = (props) => {
	return (
		<ThemeProvider theme={theme}>
			<GlobalStyles />
			{props.children}
		</ThemeProvider>
	)
}
